import React, { useState } from 'react';

interface UserLeadsProps {
  profilePictureUrl: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
  leads: number;
}

const UserLeads: React.FC<UserLeadsProps> = ({
  profilePictureUrl,
  firstName,
  lastName,
  jobTitle,
  leads,
}) => {
  const getInitials = (name: string) => {
    const initials = name
      .split(' ')
      .map((part) => part.charAt(0))
      .join('')
      .toUpperCase();
    return initials || 'U';
  };

  const baseLeadStyle = 'rounded-md text-white text-[0.7rem] p-1'

  return (
    <div className="grow border rounded-md border-slate-300 w-64 p-4 m-2">
      <div className="flex mb-5">
        {profilePictureUrl ? (
          <img
            className="size-20 rounded-full mr-5"
            src={profilePictureUrl}
            alt="Profile"
          />
        ) : (
          <div className="size-20 rounded-full bg-gray-500 dark:bg-gray-700 text-white flex items-center justify-center text-3xl font-semibold mr-5">
            {getInitials(`${firstName} ${lastName}`)}
          </div>
        )}
        <div className="">
          <div className="flex flex-col mb-4">
            <span className="text-slate-700 text-[0.65rem] tracking-widest dark:text-slate-400">
              EMPLOYEE
            </span>
            <span className="text-slate-800 dark:text-white font-bold">{`${firstName} ${lastName}`}</span>
          </div>
          <div className="flex flex-col">
            <span className="text-slate-700 text-[0.65rem] tracking-widest dark:text-slate-400">
              TITLE
            </span>
            <span className="text-slate-800 dark:text-white font-bold">{jobTitle}</span>
          </div>
        </div>
      </div>
      <hr />
      <div className="flex items-center justify-between mt-5">
        <span className="font-bold">Total Weekly Leads</span>
        {leads >= 5 ? (
          <span className={`bg-green-500 ${baseLeadStyle}`}>
            {`${leads} / 5`}
          </span>
        ) : (
          <span className={`bg-red-500 ${baseLeadStyle}`}>
            {`${leads} / 5`}
          </span>
        )}
      </div>
    </div>
  );
};

export default UserLeads;
